import { Component, Input, OnInit } from '@angular/core';
import { PlatformEnum, PlatformService } from '@panamax/app-state';
import { SupportCenterContentViewModel } from '@app/support-center/model/support-center-model';
import { SupportCenterService } from '@app/support-center/services/support-center.service';
import {
  ServiceRequestType,
  SousStatus,
  SubmittedByUser,
} from '@usf/list-types';
import { ListAnalyticsService } from '@usf/ngrx-list';

@Component({
  selector: 'app-support-center-modal',
  templateUrl: './support-center-modal.component.html',
  styleUrls: ['./support-center-modal.component.scss'],
})
export class SupportCenterModalComponent implements OnInit {
  @Input() platformType: PlatformEnum;
  @Input() supportItem: SupportCenterContentViewModel;

  readonly serviceRequestType = ServiceRequestType;
  readonly platformEnum = PlatformEnum;
  supportRef = SousStatus;
  modalTitle: string;
  formattedUserName: string;
  isValidUnitType = false;
  isRecoveryRequest = false;

  constructor(
    private supportCenterService: SupportCenterService,
    private listAnalyticsService: ListAnalyticsService,
  ) {}

  ngOnInit(): void {
    this.modalTitle = this.getModalTitle(this.supportItem.serviceRequestType);
    this.formattedUserName = this.getFormattedUserName(
      this.supportItem?.submittedByUser,
    );
    this.isValidUnitType = this.isASupportedQuantityType(
      this.supportItem.unitOfMeasure,
    );
    this.isRecoveryRequest = this.isARecoveryRequest(
      this.supportItem.serviceRequestType,
    );
  }

  getModalTitle(serviceRequestType: ServiceRequestType): string {
    let title;
    switch (serviceRequestType) {
      case ServiceRequestType.REQUEST_CREDIT:
        title = 'i18n.supportCenter.request.credit';
        break;
      case ServiceRequestType.PICKUP_REQUEST:
        title = 'i18n.supportCenter.request.pickup';
        break;
      case ServiceRequestType.RECOVERY_REQUEST:
        title = 'i18n.supportCenter.request.recovery';
        break;
      case ServiceRequestType.SUPPORT_REQUEST:
        title = 'i18n.supportCenter.request.support';
        break;
    }
    return title;
  }

  isASupportedQuantityType(quantityType: string) {
    if (!quantityType) {
      return false;
    }

    return quantityType === 'Cases' || quantityType === 'Each';
  }

  getFormattedUserName(user: SubmittedByUser): string {
    if (!user) {
      return 'System';
    }

    if (!user.firstName && !user.lastName && !user.userName) {
      return 'System';
    }

    if (!user.firstName && !user.lastName) {
      return `(${user.userName})`;
    }

    return !user.userName
      ? `${user.firstName ?? ''} ${user.lastName ?? ''}`.trim()
      : `${user.firstName ?? ''} ${user.lastName ?? ''} (${user.userName ?? ''})`.trim();
  }

  async onDidDismiss() {
    this.supportCenterService.dismissModal();
  }

  resubmit() {
    this.listAnalyticsService.trackSupportCenterResubmitRequest(
      this.supportItem.serviceRequestType,
    );
    this.supportCenterService.requestResubmit(this.supportItem.mongoRecordId);
    this.supportCenterService.dismissModal();
  }

  isARecoveryRequest(serviceRequestType: ServiceRequestType) {
    return ServiceRequestType.RECOVERY_REQUEST === serviceRequestType;
  }
}
